import PageLoading from "components/base/PageLoading";
import useStringQueryParam from "hooks/useStringQueryParam";
import React from "react";
import { Redirect, useLocation } from "react-router";
import { IRouteConfig } from "services/typings";
import { isBSP, isMicroApp } from "utils/microApp";
import { lazy } from "utils/route";

const routes = [
  {
    path: "/payment/callback",
    component: lazy(() => import("./pages/PaymentCallback")),
    hideInMenu: true,
    exact: true,
  },
  isMicroApp &&
    !isBSP && {
      path: "/",
      component: lazy(() => import("./Seller")),
      hideInMenu: true,
      routes: [
        {
          path: "/program/create",
          component: lazy(() => import("./pages/Program/pages/ProgramCompose")),
          hideInMenu: true,
          exact: true,
        },
        {
          path: "/program/:id/edit",
          component: lazy(() => import("./pages/Program/pages/ProgramCompose")),
          hideInMenu: true,
          exact: true,
        },
        {
          path: "/program/:id/:tab",
          component: lazy(() => import("./pages/Program/pages/ProgramDetail")),
          hideInMenu: true,
          exact: true,
        },
        {
          path: "/report",
          component: function Component() {
            const [seller_id] = useStringQueryParam<number>({
              key: "seller_id",
              method: "replace",
            });
            return <Redirect to={`/report/campaign?seller_id=${seller_id}`} />;
          },
          hideInMenu: true,
          placeholder: () => <PageLoading loading />,
          exact: true,
        },
        {
          path: "/:tab",
          component: lazy(() => import("./components/Content")),
          hideInMenu: true,
          placeholder: () => <PageLoading loading />,
          exact: true,
        },
        {
          path: "/:tab/:type",
          component: lazy(() => import("./components/Content")),
          hideInMenu: true,
          placeholder: () => <PageLoading loading />,
          exact: true,
        },
      ],
    },
].filter(Boolean);

export default routes;
